import { registerFunctionalComponent } from 'js/lib/components/component'

registerFunctionalComponent('.js-c-ui-effects-parallax', 'UiEffectsParallaxComponent', initParallax)

function initParallax(component) {
  const inner = component.element.querySelector('.js-c-ui-effects-parallax__inner')
  if (!inner || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

  const intensity = parseInt(component.element.dataset.intensity, 10) || 12
  const images = inner.querySelectorAll('img')
  let frame = null

  const configureLayout = () => {
    component.element.style.height = ''
    inner.style.height = ''
    inner.style.marginTop = ''
    inner.style.transform = ''

    const height = component.element.clientHeight
    if (!height) return

    component.element.style.height = `${height}px`
    inner.style.height = `${height + intensity * 2}px`
    inner.style.marginTop = `${intensity * -1}px`
  }

  const update = () => {
    frame = null

    const rect = component.element.getBoundingClientRect()
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight
    const progress = ((rect.top + rect.height / 2) - viewportHeight / 2) / viewportHeight
    const offset = Math.max(Math.min(progress * intensity, intensity), -intensity)

    inner.style.transform = `translate3d(0, ${offset}px, 0)`
  }

  const requestUpdate = () => {
    if (frame) return
    frame = window.requestAnimationFrame(update)
  }

  const handleResize = () => {
    configureLayout()
    requestUpdate()
  }

  component.useHandler(() => {
    window.addEventListener('scroll', requestUpdate, { passive: true })
    window.addEventListener('resize', handleResize)
    images.forEach(image => image.addEventListener('load', handleResize))
    handleResize()

    return () => {
      window.removeEventListener('scroll', requestUpdate)
      window.removeEventListener('resize', handleResize)
      images.forEach(image => image.removeEventListener('load', handleResize))

      if (frame) window.cancelAnimationFrame(frame)

      component.element.style.height = ''
      inner.style.height = ''
      inner.style.marginTop = ''
      inner.style.transform = ''
    }
  })
}
